export enum SocialType {
    DISCORD = 'DISCORD',
    REDDIT = 'REDDIT',
    X = 'X'
}
